import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AiOutlineMail } from "react-icons/ai";
import { useSelector } from "react-redux";
import { LOCALES } from "common/constants";

const ContactUsForm = ({
  t,
  handleSubmit,
  onSubmit,
  register,
  language,
  errors,
}) => {
  const user = useSelector((state) => state.auth.user);

  return (
    <section className="feedbacks mb-0" id="Counseling">
      <div className="container">
        <div className="contact-form-wrap mx-auto">
          <form
            className="w-100 py-5 m-auto text-center px-5 bg-light rounded"
            onSubmit={handleSubmit(onSubmit)}
          >
            <h6>
              {t(
                "You can also fill in the contact form below with your details and your message, and we will get back to you as soon as possible."
              )}
            </h6>
            <h2 className="mb-5 mt-0 text-dark">{t("Contact form")}</h2>

            <div className="d-flex mb-3 flex-xs-column">
              <div className="w-50 m-0 mr-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("Name")}
                  style={{ border: errors?.name && "1px solid #dc3545" }}
                  {...register("name", { required: t("Name is required") })}
                />
                {errors.name && (
                  <p className="error-note">{errors.name.message}</p>
                )}
              </div>

              <div className="w-50 m-0 mr-2">
                <input
                  type="text"
                  className="form-control"
                  style={{ border: errors?.email && "1px solid #dc3545" }}
                  placeholder={t("Email address")}
                  {...register("email", {
                    required: t("Email is required"),
                    pattern: {
                      value:
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                      message: t("Please enter a valid email address"),
                    },
                  })}
                />
                {errors.email && (
                  <p className="error-note">{errors.email.message}</p>
                )}
              </div>
            </div>

            <div className="d-flex mb-3 flex-xs-column">
              <div className="w-50 m-0 mr-2">
                <input
                  type="text"
                  className="form-control"
                  style={{ border: errors?.phoneNumber && "1px solid #dc3545" }}
                  placeholder={t("Phone")}
                  {...register("phoneNumber", {
                    required: t("Phone number is required"),
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(
                      /[^0-9+()\- ]/g,
                      ""
                    );
                  }}
                />
                {errors.phoneNumber && (
                  <p className="error-note">{errors.phoneNumber.message}</p>
                )}
              </div>

              <div className="w-50 m-0 mr-2">
                <input
                  type="text"
                  className="form-control"
                  style={{ border: errors?.subject && "1px solid #dc3545" }}
                  placeholder={t("Subject")}
                  {...register("subject", {
                    required: t("Subject is required"),
                  })}
                />
                {errors.subject && (
                  <p className="error-note">{errors.subject.message}</p>
                )}
              </div>
            </div>

            <div className="mb-3">
              <textarea
                type="text"
                className="form-control w-190 m-0"
                style={{ border: errors?.message && "1px solid #dc3545" }}
                placeholder={t("Message")}
                {...register("message", {
                  required: t("Message is required"),
                })}
              />
              {errors.message && (
                <p className="error-note">{errors.message.message}</p>
              )}
            </div>

            <Button
              variant="primary send_contactus"
              type="submit"
              className="mt-2 text-light new_theme_btn"
              size="lg"
              style={{ backgroundColor: "#886cc1" }}
            >
              {t("Send")}
            </Button>
            <p className="text-body mt-3">
              {t("We look forward to hearing from you!")}
            </p>
            <p className="text-body">
              {t(
                "Please note: If you are an existing customer and need help with a specific invoice or payment, please include relevant information in your message to speed up the process. Your privacy is important to us. We handle all personal information in accordance with our privacy policy."
              )}
            </p>
            <ul className="d-flex flex-wrap justify-content-center">
              <li>{t("Links")}: </li>
              <li>
                <Link
                  style={{ textDecoration: "underline" }}
                  className="how_calculate_link"
                  to={
                    language === LOCALES.EN_US
                      ? `/?lang=${LOCALES.EN_US}`
                      : `/?lang=${LOCALES.SV_SE}`
                  }
                  target="_blank"
                >
                  {t("Home")}
                </Link>
              </li>
              <li>
                <Link
                  className="how_calculate_link"
                  to={
                    language === LOCALES.EN_US
                      ? `/about-invozio?lang=${LOCALES.EN_US}`
                      : `/om-invozio?lang=${LOCALES.SV_SE}`
                  }
                  target="_blank"
                  style={{ textDecoration: "underline" }}
                >
                  {t("About us")}
                </Link>
              </li>
              <li>
                <Link
                  style={{ textDecoration: "underline" }}
                  className="how_calculate_link"
                  to={
                    language === LOCALES.EN_US
                      ? `/dashboard/faq?lang=${LOCALES.EN_US}`
                      : `/instrumentbrada/faq?lang=${LOCALES.SV_SE}`
                  }
                  target="_blank"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link
                  style={{ textDecoration: "underline" }}
                  className="how_calculate_link"
                  to={
                    user
                      ? language === LOCALES.EN_US
                        ? `/dashboard/ambassador?lang=${LOCALES.EN_US}`
                        : `/instrumentbrada/ambassador?lang=${LOCALES.SV_SE}`
                      : language === LOCALES.EN_US
                      ? `/ambassador?lang=${LOCALES.EN_US}`
                      : `/ambassador?lang=${LOCALES.SV_SE}`
                  }
                  target="_blank"
                >
                  {t("Become an Ambassador")}
                </Link>
              </li>
            </ul>
          </form>
        </div>
      </div>

      <div className="container about pb-0">
        <div className="hading-text pb-1 pt-4">
          <h5 className="text-bold font-weight-bold text-center mb-2">
            {t("Talk to our specialists")}
          </h5>
          <p className="mb-4 mt-2 text-center">
            {t("Do you have specific questions or concerns about an area?")}
            <br></br> {t("Our advisors help you with all your questions.")}
          </p>
        </div>
        <div className=" Contact-width ">
          <div className="row align-items-center justify-content-center">
            <div className="col-md-12 text-center col-sm-6">
              <p className="text-bold">
                {t("Contact Us on")}
                <br></br>{" "}
                <a href="mailto:support@invozio.com" className="text-bold">
                  <u className="text-bold">support@invozio.com</u>
                </a>
              </p>
              <Button
                variant="primary last_contactUs new_btn_sets"
                href="mailto:support@invozio.com"
                className="mt-1 text-light new_theme_btn"
              >
                <AiOutlineMail className="mr-2"></AiOutlineMail>
                {t("Contact")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUsForm;
